<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: "App",
    mounted() {
      // window.addEventListener("error", (event) => {
      //   // console.log("window error on listener---", event);
      //   alert(JSON.stringify(event))
      // });
    },
  };
</script>

<style lang="less" scoped>
  #app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-touch-callout: none !important;
   /* -webkit-user-select: none;
    moz-user-select: -moz-none;
    -moz-user-select: none;
    -o-user-select: none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;*/
    min-height: 100vh;
    overflow: scroll;
    background: #f6f6f6;
    color: #000;
    /* text-align: center; */
  }
</style>
<style>
  .lx-load-box {
    width: 2em !important;
    min-height: 2em !important;
    margin-left: -1em !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue